module.exports = { 
      attributes: {"title":"Shogi evening","date":"2022-06-21T00:00:00.000Z","author":"Xunnozza","categories":["news"],"tags":["news"],"language":"en","section":null},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("The Corona theme had us firmly in its grip for a long time,\nwhich of course also had a strong impact on our Club/Shogi evenings,\nso that the number of players decreased strongly and many did not come back.")]),_vm._v(" "),_c('p',[_vm._v("It is all the more pleasing that after a long time we again had a well-attended day.\nMany new players joined us in the last weeks.\nUnfortunately we could not break our previous record (number of shogi players on a game evening),\nbut we are optimistic that this will be the case soon.")]),_vm._v(" "),_c('p',[_vm._v("On nice summer days we now play outside, right next to the normal meeting place.")]),_vm._v(" "),_c('image-reel',[_vm._v("\nShogi Abend|/sommer2022/shogievening.jpg\n")])],1) };
            this.$options.staticRenderFns = [];
          }
        }
      },
     }